// Comprehensive country-timezone mapping database
// Excluding EU for now as requested, focusing on clear single-timezone countries

export const COUNTRY_TIMEZONES = {
  // Africa
  'Morocco': {
    timezone: 'Africa/Casablanca',
    utcOffset: '+01:00',
    name: 'Western European Summer Time',
    abbreviation: 'WEST',
    capital: 'Rabat'
  },
  'Egypt': {
    timezone: 'Africa/Cairo',
    utcOffset: '+02:00',
    name: 'Eastern European Time',
    abbreviation: 'EET',
    capital: 'Cairo'
  },
  'South Africa': {
    timezone: 'Africa/Johannesburg',
    utcOffset: '+02:00',
    name: 'South Africa Standard Time',
    abbreviation: 'SAST',
    capital: 'Pretoria'
  },
  'Nigeria': {
    timezone: 'Africa/Lagos',
    utcOffset: '+01:00',
    name: 'West Africa Time',
    abbreviation: 'WAT',
    capital: 'Abuja'
  },
  'Kenya': {
    timezone: 'Africa/Nairobi',
    utcOffset: '+03:00',
    name: 'East Africa Time',
    abbreviation: 'EAT',
    capital: 'Nairobi'
  },
  'Ethiopia': {
    timezone: 'Africa/Addis_Ababa',
    utcOffset: '+03:00',
    name: 'East Africa Time',
    abbreviation: 'EAT'
  },
  'Tanzania': {
    timezone: 'Africa/Dar_es_Salaam',
    utcOffset: '+03:00',
    name: 'East Africa Time',
    abbreviation: 'EAT'
  },
  'Uganda': {
    timezone: 'Africa/Kampala',
    utcOffset: '+03:00',
    name: 'East Africa Time',
    abbreviation: 'EAT'
  },
  'Ghana': {
    timezone: 'Africa/Accra',
    utcOffset: '+00:00',
    name: 'Greenwich Mean Time',
    abbreviation: 'GMT'
  },
  'Rwanda': {
    timezone: 'Africa/Kigali',
    utcOffset: '+02:00',
    name: 'Central Africa Time',
    abbreviation: 'CAT'
  },
  'Zambia': {
    timezone: 'Africa/Lusaka',
    utcOffset: '+02:00',
    name: 'Central Africa Time',
    abbreviation: 'CAT'
  },

  // Asia
  'Japan': {
    timezone: 'Asia/Tokyo',
    utcOffset: '+09:00',
    name: 'Japan Standard Time',
    abbreviation: 'JST',
    capital: 'Tokyo'
  },
  'China': {
    timezone: 'Asia/Shanghai',
    utcOffset: '+08:00',
    name: 'China Standard Time',
    abbreviation: 'CST',
    capital: 'Beijing'
  },
  'India': {
    timezone: 'Asia/Kolkata',
    utcOffset: '+05:30',
    name: 'India Standard Time',
    abbreviation: 'IST'
  },
  'Thailand': {
    timezone: 'Asia/Bangkok',
    utcOffset: '+07:00',
    name: 'Indochina Time',
    abbreviation: 'ICT'
  },
  'Singapore': {
    timezone: 'Asia/Singapore',
    utcOffset: '+08:00',
    name: 'Singapore Standard Time',
    abbreviation: 'SGT'
  },
  'UAE': {
    timezone: 'Asia/Dubai',
    utcOffset: '+04:00',
    name: 'Gulf Standard Time',
    abbreviation: 'GST'
  },
  'Saudi Arabia': {
    timezone: 'Asia/Riyadh',
    utcOffset: '+03:00',
    name: 'Arabia Standard Time',
    abbreviation: 'AST'
  },
  'Qatar': {
    timezone: 'Asia/Qatar',
    utcOffset: '+03:00',
    name: 'Arabia Standard Time',
    abbreviation: 'AST'
  },
  'Kuwait': {
    timezone: 'Asia/Kuwait',
    utcOffset: '+03:00',
    name: 'Arabia Standard Time',
    abbreviation: 'AST'
  },
  'Bahrain': {
    timezone: 'Asia/Bahrain',
    utcOffset: '+03:00',
    name: 'Arabia Standard Time',
    abbreviation: 'AST'
  },
  'Oman': {
    timezone: 'Asia/Muscat',
    utcOffset: '+04:00',
    name: 'Gulf Standard Time',
    abbreviation: 'GST'
  },
  'Jordan': {
    timezone: 'Asia/Amman',
    utcOffset: '+02:00',
    name: 'Eastern European Time',
    abbreviation: 'EET'
  },
  'Lebanon': {
    timezone: 'Asia/Beirut',
    utcOffset: '+02:00',
    name: 'Eastern European Time',
    abbreviation: 'EET'
  },
  'Israel': {
    timezone: 'Asia/Jerusalem',
    utcOffset: '+02:00',
    name: 'Israel Standard Time',
    abbreviation: 'IST'
  },
  'South Korea': {
    timezone: 'Asia/Seoul',
    utcOffset: '+09:00',
    name: 'Korea Standard Time',
    abbreviation: 'KST'
  },
  'Indonesia': {
    timezone: 'Asia/Jakarta',
    utcOffset: '+07:00',
    name: 'Western Indonesia Time',
    abbreviation: 'WIB'
  },
  'Malaysia': {
    timezone: 'Asia/Kuala_Lumpur',
    utcOffset: '+08:00',
    name: 'Malaysia Time',
    abbreviation: 'MYT'
  },
  'Philippines': {
    timezone: 'Asia/Manila',
    utcOffset: '+08:00',
    name: 'Philippine Time',
    abbreviation: 'PHT'
  },
  'Vietnam': {
    timezone: 'Asia/Ho_Chi_Minh',
    utcOffset: '+07:00',
    name: 'Indochina Time',
    abbreviation: 'ICT'
  },
  'Pakistan': {
    timezone: 'Asia/Karachi',
    utcOffset: '+05:00',
    name: 'Pakistan Standard Time',
    abbreviation: 'PKT'
  },
  'Bangladesh': {
    timezone: 'Asia/Dhaka',
    utcOffset: '+06:00',
    name: 'Bangladesh Standard Time',
    abbreviation: 'BST'
  },
  'Sri Lanka': {
    timezone: 'Asia/Colombo',
    utcOffset: '+05:30',
    name: 'Sri Lanka Standard Time',
    abbreviation: 'SLST'
  },
  'Nepal': {
    timezone: 'Asia/Kathmandu',
    utcOffset: '+05:45',
    name: 'Nepal Time',
    abbreviation: 'NPT'
  },

  // Europe (Major Countries)
  'United Kingdom': {
    timezone: 'Europe/London',
    utcOffset: '+01:00', // BST (British Summer Time)
    name: 'British Summer Time',
    abbreviation: 'BST',
    capital: 'London'
  },
  'Germany': {
    timezone: 'Europe/Berlin',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'France': {
    timezone: 'Europe/Paris',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'Italy': {
    timezone: 'Europe/Rome',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'Spain': {
    timezone: 'Europe/Madrid',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'Netherlands': {
    timezone: 'Europe/Amsterdam',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'Belgium': {
    timezone: 'Europe/Brussels',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'Switzerland': {
    timezone: 'Europe/Zurich',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'Austria': {
    timezone: 'Europe/Vienna',
    utcOffset: '+02:00',
    name: 'Central European Summer Time',
    abbreviation: 'CEST'
  },
  'Sweden': {
    timezone: 'Europe/Stockholm',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Norway': {
    timezone: 'Europe/Oslo',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Denmark': {
    timezone: 'Europe/Copenhagen',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Finland': {
    timezone: 'Europe/Helsinki',
    utcOffset: '+02:00',
    name: 'Eastern European Time',
    abbreviation: 'EET'
  },
  'Poland': {
    timezone: 'Europe/Warsaw',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Czech Republic': {
    timezone: 'Europe/Prague',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Hungary': {
    timezone: 'Europe/Budapest',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Portugal': {
    timezone: 'Europe/Lisbon',
    utcOffset: '+00:00',
    name: 'Western European Time',
    abbreviation: 'WET'
  },
  'Greece': {
    timezone: 'Europe/Athens',
    utcOffset: '+02:00',
    name: 'Eastern European Time',
    abbreviation: 'EET'
  },
  'Romania': {
    timezone: 'Europe/Bucharest',
    utcOffset: '+02:00',
    name: 'Eastern European Time',
    abbreviation: 'EET'
  },
  'Bulgaria': {
    timezone: 'Europe/Sofia',
    utcOffset: '+02:00',
    name: 'Eastern European Time',
    abbreviation: 'EET'
  },
  'Croatia': {
    timezone: 'Europe/Zagreb',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Slovenia': {
    timezone: 'Europe/Ljubljana',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Slovakia': {
    timezone: 'Europe/Bratislava',
    utcOffset: '+01:00',
    name: 'Central European Time',
    abbreviation: 'CET'
  },
  'Ireland': {
    timezone: 'Europe/Dublin',
    utcOffset: '+00:00',
    name: 'Greenwich Mean Time',
    abbreviation: 'GMT'
  },
  'Iceland': {
    timezone: 'Atlantic/Reykjavik',
    utcOffset: '+00:00',
    name: 'Greenwich Mean Time',
    abbreviation: 'GMT'
  },

  // Americas - United States
  'United States': {
    timezone: 'America/New_York', // Official Eastern Time
    utcOffset: '-04:00',
    name: 'Eastern Daylight Time',
    abbreviation: 'EDT',
    capital: 'Washington, D.C.'
  },

  // Canada
  'Canada': {
    timezone: 'America/Toronto', // Official Eastern Time
    utcOffset: '-05:00',
    name: 'Eastern Standard Time',
    abbreviation: 'EST'
  },

  // Brazil
  'Brazil': {
    timezone: 'America/Sao_Paulo',
    utcOffset: '-03:00',
    name: 'Brasilia Time',
    abbreviation: 'BRT'
  },

  // Argentina
  'Argentina': {
    timezone: 'America/Argentina/Buenos_Aires',
    utcOffset: '-03:00',
    name: 'Argentina Time',
    abbreviation: 'ART'
  },

  // Chile
  'Chile': {
    timezone: 'America/Santiago',
    utcOffset: '-04:00',
    name: 'Chile Standard Time',
    abbreviation: 'CLT'
  },

  // Oceania
  'Australia': {
    timezone: 'Australia/Sydney', // Official Sydney Time
    utcOffset: '+10:00',
    name: 'Australian Eastern Standard Time',
    abbreviation: 'AEST'
  },

  'New Zealand': {
    timezone: 'Pacific/Auckland',
    utcOffset: '+12:00',
    name: 'New Zealand Standard Time',
    abbreviation: 'NZST'
  },
  'Fiji': {
    timezone: 'Pacific/Fiji',
    utcOffset: '+12:00',
    name: 'Fiji Time',
    abbreviation: 'FJT'
  },

  // Other regions
  'Turkey': {
    timezone: 'Europe/Istanbul',
    utcOffset: '+03:00',
    name: 'Turkey Time',
    abbreviation: 'TRT'
  },
  'Russia': {
    timezone: 'Europe/Moscow', // Moscow time as default
    utcOffset: '+03:00',
    name: 'Moscow Standard Time',
    abbreviation: 'MSK',
    note: 'Multiple timezones - using Moscow as default'
  },
  'Iran': {
    timezone: 'Asia/Tehran',
    utcOffset: '+03:30',
    name: 'Iran Standard Time',
    abbreviation: 'IRST'
  },
  'Afghanistan': {
    timezone: 'Asia/Kabul',
    utcOffset: '+04:30',
    name: 'Afghanistan Time',
    abbreviation: 'AFT'
  },
  'Myanmar': {
    timezone: 'Asia/Yangon',
    utcOffset: '+06:30',
    name: 'Myanmar Time',
    abbreviation: 'MMT'
  },
  'Cambodia': {
    timezone: 'Asia/Phnom_Penh',
    utcOffset: '+07:00',
    name: 'Indochina Time',
    abbreviation: 'ICT'
  },
  'Laos': {
    timezone: 'Asia/Vientiane',
    utcOffset: '+07:00',
    name: 'Indochina Time',
    abbreviation: 'ICT'
  },
  'Mongolia': {
    timezone: 'Asia/Ulaanbaatar',
    utcOffset: '+08:00',
    name: 'Ulaanbaatar Time',
    abbreviation: 'ULAT'
  }
};

/**
 * Get timezone information for a country
 * @param {string} countryName - Name of the country
 * @returns {Object|null} Timezone information or null if not found
 */
export const getCountryTimezone = (country) => {
  // Handle both string and object formats
  const countryName = typeof country === 'string' ? country : country?.name;
  return countryName ? COUNTRY_TIMEZONES[countryName] || null : null;
};

/**
 * Check if a country has timezone information available
 * @param {string} countryName - Name of the country
 * @returns {boolean} True if timezone info is available
 */
export const hasTimezoneInfo = (country) => {
  // Handle both string and object formats
  const countryName = typeof country === 'string' ? country : country?.name;
  return countryName && countryName in COUNTRY_TIMEZONES;
};

/**
 * Convert a date to a specific timezone
 * @param {Date|string} date - Date to convert
 * @param {string} timezone - Target timezone (e.g., 'Asia/Tokyo')
 * @returns {Date} Date object in the target timezone
 */
export const convertToTimezone = (date, timezone) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  // Create a new date in the target timezone
  const utcTime = dateObj.getTime() + (dateObj.getTimezoneOffset() * 60000);
  const targetTime = new Date(utcTime + (getTimezoneOffset(timezone) * 60000));

  return targetTime;
};

/**
 * Get timezone offset in minutes for a given timezone
 * @param {string} timezone - Timezone identifier
 * @returns {number} Offset in minutes
 */
const getTimezoneOffset = (timezone) => {
  const now = new Date();
  const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
  const target = new Date(utc.toLocaleString('en-US', { timeZone: timezone }));
  return (target.getTime() - utc.getTime()) / 60000;
};

/**
 * Calculate visa validity period in the issuing country's timezone
 * @param {string} issueDate - Visa issue date (YYYY-MM-DD)
 * @param {number} durationDays - Visa duration in days
 * @param {string} countryName - Visa issuing country
 * @returns {Object} Visa validity information
 */
export const calculateVisaValidity = (issueDate, durationDays, country) => {
  const countryTz = getCountryTimezone(country);
  const countryName = typeof country === 'string' ? country : country?.name;

  if (!countryTz) {
    throw new Error(`Timezone information not available for ${countryName}`);
  }

  // Helper to create a date in a specific timezone
  // We use the Intl.DateTimeFormat to get the parts in the target timezone
  // and then reconstruct the date to ensure we have the correct instant in time
  const createDateInTimezone = (dateStr, timeStr, timezone) => {
    // 1. Create a temporary date object from the string (interpreted as local or UTC)
    // We just need the components Y, M, D

    // 2. We want to find the UTC timestamp that corresponds to Y-M-D H:M:S in the TARGET timezone.
    // There isn't a direct "Date.fromTimezone" method, so we have to approximate or use a library.
    // Since we can't add libraries, we'll use a robust approximation:
    // Create a UTC date with the desired components, then adjust by the offset.

    // However, offset varies by DST. A better native way:
    // Create a date that we *think* is close, then adjust until its .toLocaleString(timezone) matches our target.

    // Let's try a simpler approach for this specific app requirement:
    // The user wants the visa to be valid from 00:00:01 on the issue date IN THE COUNTRY'S TIMEZONE.
    // And expire at 23:59:59 on the end date IN THE COUNTRY'S TIMEZONE.

    // We can construct a string that Date.parse might accept with timezone, but browser support varies.
    // Best reliable way without libraries (like moment-timezone) is to use the offset provided in our map if static,
    // OR use the Intl API to reverse-engineer.

    // Given we have `utcOffset` in our data (e.g. '+01:00'), let's use that for a "good enough" estimation
    // if we assume standard/summer time is handled or if we accept slight deviation.
    // BUT, the user explicitly asked for "best approach".

    // Let's use the `toLocaleString` approach to get the offset dynamically for the specific date.

    const targetTimeIso = `${dateStr}T${timeStr}`; // e.g., "2024-01-01T00:00:01"

    // We want a Date object 'd' such that d.toLocaleString('en-US', {timeZone: timezone}) ~= targetTimeIso

    // Start with UTC assumption
    let estimatedDate = new Date(`${targetTimeIso}Z`);

    // Refine loop (usually takes 1-2 iterations)
    for (let i = 0; i < 3; i++) {
      const parts = new Intl.DateTimeFormat('en-US', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false,
        timeZone: timezone
      }).formatToParts(estimatedDate);

      const part = (type) => parts.find(p => p.type === type).value;

      // Construct what the date "looks like" in the target timezone
      let hour = part('hour');
      if (hour === '24') hour = '00';

      const currentInTz = new Date(`${part('year')}-${part('month')}-${part('day')}T${hour}:${part('minute')}:${part('second')}Z`);
      const targetInUtc = new Date(`${targetTimeIso}Z`);

      const diff = targetInUtc.getTime() - currentInTz.getTime();

      if (Math.abs(diff) < 1000) break; // Close enough

      estimatedDate = new Date(estimatedDate.getTime() + diff);
    }

    return estimatedDate;
  };

  // Visa validity always starts at 00:00:01 on the issue date in the country's capital timezone
  // The timezone is already set to the capital city (e.g., 'Africa/Casablanca' for Morocco)
  const startDate = createDateInTimezone(issueDate, '00:00:01', countryTz.timezone);

  // Calculate end date string
  // For a visa valid for N days starting on issue date:
  // - Day 1 is the issue date
  // - Day N is issue date + (N - 1) days
  // - End time is 23:59:59 on day N in the country's capital timezone
  const [y, m, d] = issueDate.split('-').map(Number);
  const tempDate = new Date(y, m - 1, d);
  tempDate.setDate(tempDate.getDate() + durationDays - 1); // Subtract 1 because day 1 is the issue date itself
  const endDateStr = `${tempDate.getFullYear()}-${String(tempDate.getMonth() + 1).padStart(2, '0')}-${String(tempDate.getDate()).padStart(2, '0')}`;

  // End date is 23:59:59 (11:59:59 PM) on the last day in the country's capital timezone
  const endDate = createDateInTimezone(endDateStr, '23:59:59', countryTz.timezone);

  return {
    countryTimezone: countryTz.timezone,
    countryName: countryTz.name,
    countryAbbr: countryTz.abbreviation,
    capital: countryTz.capital,
    startDateTime: startDate,
    endDateTime: endDate,
    startDateString: startDate.toISOString(),
    endDateString: endDate.toISOString(),
    durationDays,
    isValid: (date = new Date()) => {
      const checkDate = typeof date === 'string' ? new Date(date) : date;
      return checkDate >= startDate && checkDate <= endDate;
    },
    getRemainingTime: (currentDate = new Date()) => {
      const current = typeof currentDate === 'string' ? new Date(currentDate) : currentDate;
      const remaining = endDate.getTime() - current.getTime();

      if (remaining <= 0) {
        return {
          expired: true,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          totalSeconds: 0
        };
      }

      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      return {
        expired: false,
        days,
        hours,
        minutes,
        seconds,
        totalSeconds: Math.floor(remaining / 1000)
      };
    }
  };
};

/**
 * Compare user's timezone with visa issuing country timezone
 * @param {string} userTimezone - User's detected timezone
 * @param {string} countryName - Visa issuing country
 * @returns {Object} Comparison information
 */
export const compareTimezones = (userTimezone, country) => {
  const countryTz = getCountryTimezone(country);
  const countryName = typeof country === 'string' ? country : country?.name;

  if (!countryTz) {
    return {
      hasCountryInfo: false,
      message: `Timezone information not available for ${countryName}`
    };
  }

  const isSameTimezone = userTimezone === countryTz.timezone;

  // Calculate time difference
  const now = new Date();
  const userTime = new Date(now.toLocaleString('en-US', { timeZone: userTimezone }));
  const countryTime = new Date(now.toLocaleString('en-US', { timeZone: countryTz.timezone }));
  const timeDifference = (countryTime - userTime) / (1000 * 60 * 60); // in hours

  return {
    hasCountryInfo: true,
    isSameTimezone,
    userTimezone,
    countryTimezone: countryTz.timezone,
    countryName: countryTz.name,
    timeDifferenceHours: timeDifference,
    message: isSameTimezone
      ? `You're in the same timezone as ${countryName}`
      : `${countryName} is ${Math.abs(timeDifference)} hours ${timeDifference > 0 ? 'ahead' : 'behind'} your timezone`
  };
};

/**
 * Format time remaining in a human-readable way
 * @param {Object} remainingTime - Object from getRemainingTime()
 * @returns {string} Formatted string
 */
export const formatRemainingTime = (remainingTime) => {
  if (remainingTime.expired) {
    return 'EXPIRED';
  }

  const { days, hours, minutes, seconds } = remainingTime;

  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  } else if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  } else {
    return `${seconds}s`;
  }
};

/**
 * Get list of supported countries
 * @returns {Array} Array of country names
 */
export const getSupportedCountries = () => {
  return Object.keys(COUNTRY_TIMEZONES);
};
